import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Alert } from "../../../../components";
import axiosInstance from "../../../axios";

export const loadAllServices = createAsyncThunk(
  "getServices",
  async (object, { dispatch }) => {
    try {
      dispatch(gettingServices());
      let result = await axiosInstance.post("/viewAllServices", {
        name: object?.name,
        pageNo: object?.pageNo,
        recordsPerPage: object?.pageSize,
      });
      if (result?.status === 200) {
        dispatch(servicesResponse(result?.data?.data));
        dispatch(
          setPages({
            pageNo: object?.pageNo,
            pageSize: object?.pageSize,
            totalRecords: result?.data?.totalRecords,
          }),
        );
      } else {
        dispatch(servicesClear());
        Alert("error", "Error while loading services");
      }
    } catch (error) {
      dispatch(servicesClear());
      Alert("error", "Error while loading services");
    }
  },
);

const ServicesSlice = createSlice({
  name: "services",
  initialState: {
    data: null,
    loading: false,
    pagination: {
      pageNo: 1,
      pageSize: 20,
      totalRecords: 0,
    },
  },
  reducers: {
    gettingServices: (state) => {
      state.loading = true;
    },
    servicesResponse: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    servicesClear: (state) => {
      state.data = null;
      state.loading = false;
      state.pagination = {
        pageNo: 1,
        pageSize: 20,
        totalRecords: 0,
      };
    },
    setPages: (state, action) => {
      state.pagination = action.payload;
    },
  },
});
export const { gettingServices, servicesResponse, servicesClear, setPages } =
  ServicesSlice.actions;
export default ServicesSlice.reducer;
